import { Component, inject } from '@angular/core';
import { ToastService } from '../../../_services/toast-service/toast.service';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-toasts',
  imports: [NgbToastModule],
  templateUrl: './toasts.component.html',
})
export class ToastsComponent {
  toastService = inject(ToastService);
}
